import { render, staticRenderFns } from "./product-cart-button.vue?vue&type=template&id=648e7ba1&"
import script from "./product-cart-button.vue?vue&type=script&lang=js&"
export * from "./product-cart-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports